import { FC, useEffect } from 'react';
import { Space, Text as MantineText, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useNavigate } from 'react-router-dom';
import GrandientPaper from '../../GradientPaper';
import { RoutingS } from '../../Service/RoutingS';

const AccountAccessRevokedPage: FC = () => {
  const isPhoneDevice = useMediaQuery('(max-width: 480px)');
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Kein Account-Zugang';
  }, []);

  return (
    <GrandientPaper>
      <Space h="md" />
      <MantineText size={isPhoneDevice ? 22 : 26}>Du hast keinen Account-Zugang</MantineText>
      <Space h="xl" />
      <MantineText align="center" color="dimmed" size={isPhoneDevice ? 'sm' : 'md'}>
        Dein Zugriff auf diesen Account wurde entfernt. Melde Dich mit einem anderen Account an, um fortzufahren.
      </MantineText>
      <Space h="xl" />
      <Text
        align="center"
        sx={(theme) => ({ cursor: 'pointer', color: theme.colorScheme === 'dark' ? 'white' : theme.colors.blue[4] })}
        onClick={() => navigate(RoutingS.ROUTES.LOGIN)}
      >
        Mit anderem Account anmelden
      </Text>
    </GrandientPaper>
  );
};

export default AccountAccessRevokedPage;
